import { OnInit } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { EnvService } from './env.service';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { ToastController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';
import { Plugins } from '@capacitor/core';
import { StatusBarStyle } from '@capacitor/core';
import {Md5} from 'ts-md5/dist/md5';
const { Device } = Plugins;
const { Storage } = Plugins;
const { Geolocation } = Plugins;
const { StatusBar } = Plugins;


@Injectable({
  providedIn: 'root'
})

export class AuthService implements OnInit {
  isLoggedIn = false;
  DatiAccesso:any;
  device:any;

  DeviceName:any;
  DeviceModel:any;
  DevicePlatform:any;
  DeviceUuid:any;
  DeviceAppVersion:any;
  DeviceAppBuild:any;
  DeviceAppId:any;
  DeviceAppName:any;
  DeviceOperatingSystem:any;
  DeviceOsVersion:any;
  DeviceManufacturer:any;
  DeviceIsVirtual:any;
  DeviceMemUsed:any;
  DeviceDiskFree:any;
  DeviceDiskTotal:any;
  DeviceBatteryLevel:any;
  DeviceIsCharging:any;
  DeviceLanguageCodeResult:any;
  DeviceGradDecLat:any;
  DeviceGradDecLong:any;
  classFlatpickr:any;
  isStatusBarLight = true; //colore di sfondo = colore app - colore testo bianco
  //isStatusBarLight = false;//colore di sfondo = colore app - colore testo nero
  FLartist=false;
  matdptouchUi:any;

  constructor(
    private http: HttpClient,
    private env: EnvService,
    private router: Router,
    private toastController: ToastController,
    private alertService: AlertService,
  ) { }
  
  ngOnInit() {
  }

  login(email: String, password: string, token: String) {
    let passwordMd5:any="";
    if(password!=""){ 
      const md5 = new Md5();
      passwordMd5=md5.appendStr(password).end();   
    }
    return this.http.post(this.env.API_URL + this.env.API_PROC + 'api_login.php',
      {
        wsPgini:this.env.API_wsPgini,
        wsMode:'L',
        usrUsername: email,
        usrPassword: passwordMd5,
        wsTokenLogin: token,
        AppVersion: this.env.APP_VERSION,
        idDevice: this.DeviceUuid,
        DeviceModel: this.DeviceModel,
        DevicePlatform: this.DevicePlatform,
        DeviceManufacturer: this.DeviceManufacturer,
        DeviceGradDecLat: this.DeviceGradDecLat,
        DeviceGradDecLong: this.DeviceGradDecLong,
      }
    ).pipe(
      tap(DatiAccesso => {
        this.setStorageObject('DatiAccesso', DatiAccesso)
        
        .then(
          () => {
            //this.storage.getItem('DatiAccesso').then((result) => {console.log('My result', result);});//PIERO
            //this.storage.getItem('DatiAccesso').then((resultx) => {console.log('usernam=', resultx["last_name"]);});//PIERO
            //this.getStorageObject('DatiAccesso').then(data=>{ console.log('DatiAccesso=', JSON.stringify(data));});//PIERO
            //console.log('Device UUID is: ' + this.device.uuid);
            //console.log('model: ' + this.device.model);
            //console.log('platform: ' + this.device.platform);
            //console.log('cordova: ' + this.device.cordova);
            //console.log('version: ' + this.device.version);
            //console.log('manufacturer: ' + this.device.manufacturer);
            //console.log('isVirtual: ' + this.device.isVirtual);
            //console.log("DeviceBatteryLevel="+this.DeviceBatteryLevel);
            //console.log("DeviceIsCharging="+this.DeviceIsCharging);
            //console.log("DeviceLanguageCodeResult="+this.DeviceLanguageCodeResult);
          },
          error => {
            this.alertService.presentToast('Errore:'+' ('+DatiAccesso["wsCdrisp"]+') '+DatiAccesso["wsDsrisp"]);
          }
        );
        this.DatiAccesso = DatiAccesso;
        this.isLoggedIn = true;
        this.env.CURRENT_IdLanguage=DatiAccesso["usrIdLanguage"];//NGX-TRANSLATE Se loggato imposta la lingua scelta dall'Utente
        this.env.CURRENT_LanguageFamily=DatiAccesso["lanLanguageFamily"];//NGX-TRANSLATE Se loggato imposta la lingua scelta dall'Utente
        this.env.CURRENT_LanguageTag=DatiAccesso["lanLanguageTag"];//NGX-TRANSLATE Se loggato imposta la lingua scelta dall'Utente
        this.env.setLanguage(this.env.CURRENT_LanguageFamily);//Imposta il linguaggio a NGX-TRANSLATE
        return DatiAccesso;
      }),

    );
  }

  register(fName: String, lName: String, email: String, password: String) {
    return this.http.post(this.env.API_URL + this.env.API_PROC + 'api_register.php',
      {fName: fName, lName: lName, email: email, password: password}
    )
  }

  logout() {
    let postData = {
      wsPgini:this.env.API_wsPgini,
      wsTokenLogin: this.DatiAccesso["wsTokenLogin"],
    } 
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_logout.php', postData

    ).pipe(
      tap(data => {
        this.removeStorage("DatiAccesso");
        this.isLoggedIn = false;
        delete this.DatiAccesso;
        return data;
      })
    )
  }

  user() {
    let postData = {
      wsPgini:this.env.API_wsPgini,
      wsTokenLogin: this.DatiAccesso["wsTokenLogin"],
    } 
    return this.http.post<any>(this.env.API_URL + this.env.API_PROC + 'api_user.php', postData
    ).pipe(
      tap(user => {
        return user;     
      })
    )    
  }

  getDatiAccesso() {
    return this.getStorageObject('DatiAccesso').then(
      data => {
        this.DatiAccesso = data;
        //console.log('DatiAccessoAUTH=', JSON.stringify(this.DatiAccesso));
        if(this.DatiAccesso != null) {
          this.isLoggedIn=true;
        } else {
          this.isLoggedIn=false;
        }
      },
      error => {
        this.DatiAccesso = null;
        this.isLoggedIn=false;
      }
    );
  }

  resumeDatiAccesso() {
      return this.DatiAccesso;
  }

  /*setVariabiliApp() {
    this.geolocation.getCurrentPosition().then((resp) => {
      this.DeviceGradDecLat=resp.coords.latitude
      this.DeviceGradDecLong=resp.coords.longitude
      //console.log('lat='+this.wkGradDecLat+' long='+this.wkGradDecLong);
    }).catch((error) => {
       console.log('Error getting location', error);
    });
  }*/
  

  /*setStatusBar() {
    //console.log("Patform="+this.DevicePlatform);
    StatusBar.setStyle({
      style: this.isStatusBarLight ? StatusBarStyle.Dark : StatusBarStyle.Light
    });
    this.isStatusBarLight = !this.isStatusBarLight;

    // Display content under transparent status bar (Android only)
    StatusBar.setOverlaysWebView({
      //overlay: true //la toolbar è integrata nell'app
      overlay: false //la toolbar è separata dall'app
    });
  }*/

  async getGeoLocation() {
    const position = await Geolocation.getCurrentPosition();
    this.DeviceGradDecLat = position.coords.latitude;
    this.DeviceGradDecLong = position.coords.longitude;
  }

  async getDeviceInfo() {
    this.device = await Device.getInfo();
    //console.log("uuid="+device.uuid);
    this.DeviceName= this.device.name;//The name of the device. only IOS
    this.DeviceModel= this.device.model;//The device model. 
    this.DevicePlatform= this.device.platform;//The device platform (lowercase).web/ios/android/
    this.DeviceUuid= this.device.uuid;//The UUID of the device as available to the app
    this.DeviceAppVersion= this.device.appVersion;//The current bundle verison of the app
    this.DeviceAppBuild= this.device.appBuild;//The current bundle build of the app
    this.DeviceAppId= this.device.appId;//The bundle id of the app
    this.DeviceAppName= this.device.appName;//The display name of the app
    this.DeviceOperatingSystem= this.device.operatingSystem;//The operating system of the device
    this.DeviceOsVersion= this.device.osVersion;//The version of the device OS
    this.DeviceManufacturer= this.device.manufacturer;//	The manufacturer of the device
    this.DeviceIsVirtual= this.device.isVirtual;//Whether the app is running in a simulator/emulator
    this.DeviceMemUsed= this.device.memUsed;//Approximate memory used by the current app, in bytes
    this.DeviceDiskFree= this.device.diskFree;//How much free disk space is available in bytes
    this.DeviceDiskTotal= this.device.diskTotal;//The total size of the normal data storage path for the OS, in bytes

    const info = await Device.getBatteryInfo();
    this.DeviceBatteryLevel=info.batteryLevel;//A percentage (0 to 1) indicating how much the battery is charged
    this.DeviceIsCharging=info.isCharging;//Whether the device is charging

    const lang = await Device.getLanguageCode();
    this.DeviceLanguageCodeResult=lang.value;//es. it

    this.classFlatpickr="flatpickr-mobile";
    if(this.DevicePlatform=="web"){this.classFlatpickr="flatpickr-browser";}
    //console.log('DevicePlatform='+this.DevicePlatform+' classFlatpickr='+this.classFlatpickr);

    if(this.DevicePlatform!="web"){
      StatusBar.setStyle({
        style: this.isStatusBarLight ? StatusBarStyle.Dark : StatusBarStyle.Light
      });
      this.isStatusBarLight = !this.isStatusBarLight;

      // Display content under transparent status bar (Android only)
      StatusBar.setOverlaysWebView({
        //overlay: true //la toolbar è integrata nell'app
        overlay: false //la toolbar è separata dall'app
      });
    }

    //===MatDatepicker==============================================================
    this.matdptouchUi="true";
    //console.log("Platform="+this.DevicePlatform);
    if(this.DevicePlatform=="web"){this.matdptouchUi="false";}
    //==============================================================MatDatepicker===

  }

  //Gestisce in Memoria la coppia chiave/Json
  async setStorageObject(storageKey: string, storageJsonValue: any) {
    await Storage.set({
      key: storageKey,
      value: JSON.stringify(storageJsonValue)
    });
  }
  async getStorageObject(storageKey: string ) {
    const ret = await Storage.get({ key: storageKey });
    return JSON.parse(ret.value);
  }

  //Gestisce in memoria la coppia chiave valore
  async setStorageItem(storageKey: string, storageItemValue: any) {
    await Storage.set({
      key: storageKey,
      value: storageItemValue
    });
    const { value } = await Storage.get({ key: storageKey });
  }
  async getStorageItem(storageKey: string) {
    const {value} = await Storage.get({ key: storageKey });
    return value;
  }

  //Rimuove elemento dalla Memoria
  async removeStorage(storageKey: string) {
    await Storage.remove({ key: storageKey });
  }

  //https://stackoverflow.com/questions/33169618/an-android-app-remembers-its-data-after-uninstall-and-reinstall
  //Problema android non cancella la cache
  //this is the correct answer and it work for me (I had the same problem) 
  //To avoid this behaviou is necessary to put android:allowBackup="false" and android:fullBackupContent="false" in manifest.xml – frusso Dec 1
  //clear all
  async clearStorage(){
    await Storage.clear();
  };


}
